import { snapshot } from 'valtio';
import { PipelineSummary } from '../pipeline-summary-types';
import PipelineSummaryStore from './pipeline-summary-store';

export const setPipelineSummaryOffset = (offset: number) => {
  PipelineSummaryStore.offset = offset;
};

export const setPipelineSummary = (
  pipelineSummaries: PipelineSummary[],
  update?: boolean,
) => {
  if (update) {
    PipelineSummaryStore.pipelineSummaries = pipelineSummaries;
  } else {
    PipelineSummaryStore.pipelineSummaries?.push(...pipelineSummaries);
  }
};

export const setPipelineSummaryTotal = (total: number) => {
  PipelineSummaryStore.total = total;
};

export const toggleFiltersPanel = () => {
  const { filtersOpen } = snapshot(PipelineSummaryStore);
  PipelineSummaryStore.filtersOpen = !filtersOpen;
};
